import script from "./ApplicationShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationShell.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationShell.vue?vue&type=style&index=0&id=56b2db85&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b2db85"]])

export default __exports__